import { setCookie } from "@insite/client-framework/Common/Cookies";
import { createHandlerChainRunner, CustomHandler } from "@ucs/Store/CustomHandlerCreator";

type CustomHandlerType = CustomHandler<{ isLocalSelectedPLP: boolean }>;

export const DispatchSetIsLocalSelectedPLP: CustomHandlerType = ({ dispatch, parameter: { isLocalSelectedPLP } }) => {
    dispatch({
        type: "Custom/SetIsLocalSelectedPLP",
        isLocalSelectedPLP,
    });
};
export const PreserveCookie: CustomHandlerType = ({ dispatch, parameter: { isLocalSelectedPLP } }) => {
    setCookie("localFilterPlp", isLocalSelectedPLP.toString());
};



export const chain = [DispatchSetIsLocalSelectedPLP, PreserveCookie];

const setIsLocalSelectedPLP = createHandlerChainRunner(chain, "SetIsLocalSelectedPLP");
export default setIsLocalSelectedPLP;
